export default __webpack_public_path__ + "static/media/0063.df7ed213.png";